(function() {
    const processedStyles = new Map();
    const processedStyleTags = new Set();
    let styleCounter = 0;
    
    const styleSheet = document.createElement('style');
    styleSheet.setAttribute('nonce', window.myAppNonce || '');
    document.head.appendChild(styleSheet);
    
    function getSheet() {
        return styleSheet.sheet;
    }

    // Garante visibilidade quando o RD Station decidir mostrar o popup
    const sheet = getSheet();
    sheet.insertRule('.rdstation-popup-js-overlay, .bricks--component { visibility: visible !important; opacity: 1 !important; }', 0);

    // O RD insere o popup como <div id="popup-..." style="display: none;"> e só o exibe
    // via element.style.display = "block". No Firefox, o style bloqueado pela CSP fica vazio
    // (style=""), então nada era convertido e o popup aparecia a cada carregamento.
    // :where() zera a especificidade: a classe gerada quando o RD manda exibir vence esta regra.
    sheet.insertRule(':where(body > div[id^="popup-"]) { display: none; }', 0);

    function killChoicesAndRestoreNative() {
        const choicesContainers = document.querySelectorAll('.choices');
        choicesContainers.forEach(container => {
            const nativeSelect = container.querySelector('select');
            if (nativeSelect) {
                nativeSelect.style.display = 'block';
                nativeSelect.style.visibility = 'visible';
                nativeSelect.classList.remove('choices__input', 'visually-hidden');
                container.parentNode.insertBefore(nativeSelect, container);
                container.remove();
            }
        });
    }

    function isTargetElement(element) {
        if (!element || element.nodeType !== 1) return false;
        const targetSelectors = [
            '.bricks--component', '[id^="bricks-component-"]', '[id^="rd-"]',
            '[class^="rd-"]', '[class*="rdstation"]', '.rdstation-popup-js-overlay',
            '[id*="popup-"]', '#rd_tmgr'
        ];
        return element.closest(targetSelectors.join(', ')) !== null;
    }

    function hashStyles(styles) {
        try {
            return btoa(unescape(encodeURIComponent(styles))).replace(/[^a-zA-Z0-9]/g, '').substring(0, 16);
        } catch (e) {
            return 'style-' + Math.random().toString(36).substring(2, 11);
        }
    }
    
    function processStyleTags() {
        const styleTags = document.querySelectorAll('style:not([nonce]):not([data-style-processed])');
        styleTags.forEach(function(styleTag) {
            if (processedStyleTags.has(styleTag)) return;
            processedStyleTags.add(styleTag);
            
            const cssContent = styleTag.textContent || styleTag.innerHTML;
            if (!cssContent || cssContent.trim() === '') return;
            
            try {
                // Recria a tag com nonce em vez de quebrar o CSS em regras soltas:
                // dividir por '}' tirava as regras de dentro de @media/@keyframes
                // (ex: as regras de impressão do SweetAlert passavam a valer na tela)
                const nonceStyle = document.createElement('style');
                nonceStyle.setAttribute('nonce', window.myAppNonce || '');
                nonceStyle.textContent = cssContent;
                styleTag.parentNode.insertBefore(nonceStyle, styleTag.nextSibling);

                // Não esvazia a tag original: alterar o conteúdo de uma <style> bloqueada
                // gera nova violação de CSP no console. Ela já não é aplicada pelo navegador.
                styleTag.setAttribute('data-style-processed', 'true');
                styleTag.disabled = true;
            } catch (e) {}
        });
    }
    
    function convertInlineStylesToClass(element) {
        if (!isTargetElement(element)) return;
        const inlineStyle = element.getAttribute('style');

        // Sem trava de "já convertido": o style attribute é removido logo abaixo,
        // então o próprio elemento sai do seletor `[style]` até a RD setar um novo valor
        // (ex: display:none -> display:block). Isso deixa reconverter mudanças futuras
        // em vez de congelar o elemento no primeiro estado (que ficava com display:none
        // preso caso o CSP bloqueasse o unhide feito pela RD depois).
        if (!inlineStyle || inlineStyle.trim() === '') return;

        const sheet = getSheet();
        if (!sheet) return;

        let className;
        const styleHash = hashStyles(inlineStyle);
        if (processedStyles.has(styleHash)) {
            className = processedStyles.get(styleHash);
        } else {
            className = `auto-style-${styleCounter++}`;
            processedStyles.set(styleHash, className);
            try {
                sheet.insertRule(`.${className} { ${inlineStyle} }`, sheet.cssRules.length);
            } catch (e) { return; }
        }
        element.classList.add(className);
        element.removeAttribute('style');
    }

    function processAll() {
        killChoicesAndRestoreNative();
        document.querySelectorAll('[style]').forEach(convertInlineStylesToClass);
        processStyleTags();
    }
    
    processAll();
    setInterval(processAll, 1000);
    
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            processAll();
        });
    });
    
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();